<template>
  <div v-if="showAnnotationTool || showWheelTool" class="teacher-tools" data-testid="TeacherTools">
    <span class="teacher-tools-title">Skolotāju rīki</span>
    <layout-user-actions-global-annotation-button v-if="showAnnotationTool" />
    <layout-user-actions-student-wheel-picker v-if="showWheelTool" />
    <layout-user-actions-teacher-timer-button v-if="showTimerTool" />

    <div class="teacher-tools-close" :class="{ visible: anyToolActive }">
      <span class="teacher-tools-close-divider" />
      <button
        type="button"
        class="teacher-tools-close-button"
        data-testid="TeacherTools-close"
        aria-label="Izslēgt rīkus"
        @click="closeActiveTool"
      >
        <v-icon size="14">fa-light fa-xmark</v-icon>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { useAnnotationStore } from "~/stores/annotationStore"
import { useStudentWheelStore } from "~/stores/studentWheelStore"
import { useTeacherTimerStore } from "~/stores/teacherTimerStore"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    const annotationStore = useAnnotationStore()
    const studentWheelStore = useStudentWheelStore()
    const timerStore = useTeacherTimerStore()
    return { userStore, annotationStore, studentWheelStore, timerStore }
  },

  computed: {
    showAnnotationTool(): boolean {
      return this.userStore.isTeacherWithActiveSchoolAndProPlan
    },

    showWheelTool(): boolean {
      return this.userStore.isTeacher
    },

    showTimerTool(): boolean {
      return this.userStore.isTeacherWithActiveSchoolAndProPlan
    },

    annotationActive(): boolean {
      return this.annotationStore.annotationMode && this.annotationStore.isGlobal
    },

    anyToolActive(): boolean {
      return this.annotationActive || this.studentWheelStore.modalOpen || this.timerStore.open
    },
  },

  methods: {
    closeActiveTool() {
      if (this.annotationActive) {
        this.annotationStore.toggleAnnotationMode()
      }
      if (this.studentWheelStore.modalOpen) {
        this.studentWheelStore.setModalOpen(false)
      }
      if (this.timerStore.open) {
        this.timerStore.closeTimer()
      }
    },
  },
}
</script>

<style lang="sass">
.teacher-tools
  display: flex
  align-items: center
  gap: 2px
  padding: 0 12px

.teacher-tools-title
  white-space: nowrap
  padding-right: 12px
  border-right: 1px solid rgba(0, 0, 0, 0.1)
  margin-right: 8px

.teacher-tool-btn
  display: flex
  align-items: center
  padding: 8px 10px
  border: none
  border-radius: 8px
  background-color: transparent
  color: inherit
  cursor: pointer
  transition: background-color 0.15s

  &:hover
    background-color: rgba(0, 0, 0, 0.05)

  &.selected,
  &.selected:hover
    background-color: #F7D052

  &:hover .teacher-tool-label,
  &.selected .teacher-tool-label
    max-width: 80px
    opacity: 1
    margin-left: 8px

.teacher-tool-icon
  font-size: 18px
  opacity: 0.75

.teacher-tool-label
  font-size: 15px
  font-weight: 500
  white-space: nowrap
  overflow: hidden
  max-width: 0
  opacity: 0
  transition: max-width 0.2s ease-in-out, opacity 0.2s ease-in-out, margin-left 0.2s ease-in-out

.teacher-tools-close
  display: flex
  align-items: center
  overflow: hidden
  max-width: 0
  opacity: 0
  transition: max-width 0.2s ease-in-out, opacity 0.2s ease-in-out, margin-left 0.2s ease-in-out

  &.visible
    max-width: 36px
    opacity: 1
    margin-left: 4px

.teacher-tools-close-divider
  width: 1px
  height: 16px
  background-color: rgba(0, 0, 0, 0.1)
  margin-right: 8px
  flex-shrink: 0

.teacher-tools-close-button
  display: flex
  align-items: center
  justify-content: center
  width: 24px
  height: 24px
  padding: 0
  border: none
  border-radius: 6px
  background-color: transparent
  color: inherit
  cursor: pointer
  flex-shrink: 0
  transition: background-color 0.1s

  &:hover
    background-color: rgba(0, 0, 0, 0.1)
</style>
